module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bulb1-878648539ce35de13480eb2cca24dfe3.svg";